module.exports = __webpack_public_path__ + "img/speaker.f4239f46.svg";